import { render, staticRenderFns } from "./DeptTips.vue?vue&type=template&id=689b92b1&scoped=true&"
import script from "./DeptTips.vue?vue&type=script&lang=js&"
export * from "./DeptTips.vue?vue&type=script&lang=js&"
import style0 from "./DeptTips.vue?vue&type=style&index=0&id=689b92b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b92b1",
  null
  
)

export default component.exports